import Vue from 'vue';
import { Directus } from '@directus/sdk';
import { store } from '@/store';

const directus = new Directus(process.env.VUE_APP_API_URL, {
  auth: {
    mode: 'cookie',
    autoRefresh: false,
    msRefreshBeforeExpires: 30000,
  },
});

const successHandler = res => res;
const errorHandler = async err => {
  const status = err.response?.status;
  if (!navigator.onLine) throw new Error('No internet connection');
  if (
    status === 401 ||
    (status === 400 && err.request.responseURL.includes('refresh'))
  ) {
    await store.dispatch('setLogoutState');
    return Promise.reject(err);
  } else return Promise.reject(err);
};

directus.transport.axios.interceptors.response.use(
  successHandler,
  errorHandler,
);

// eslint-disable-next-line no-shadow
Plugin.install = Vue => {
  Vue.directus = directus;
  window.directus = directus;
  Object.defineProperties(Vue.prototype, {
    directus: {
      get() {
        return directus;
      },
    },
    $directus: {
      get() {
        return directus;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
